import { render, staticRenderFns } from "./LayoutAddressSearchBase.vue?vue&type=template&id=b44a14fe&scoped=true&"
import script from "./LayoutAddressSearchBase.vue?vue&type=script&lang=js&"
export * from "./LayoutAddressSearchBase.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAddressSearchBase.vue?vue&type=style&index=0&id=b44a14fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44a14fe",
  null
  
)

export default component.exports